// Design tokens for the Aurora dark-mode landing page.
// Scoped to /c/aurora — do not import outside this folder unless extending the
// dark theme intentionally.
export const AURORA_THEME = {
  bg: {
    primary: "#0B1026",
    surface: "#141a3a",
    elevated: "#1c2350",
  },
  accent: {
    primary: "#00FFCC",
    primarySoft: "rgba(0, 255, 204, 0.18)",
    warm: "#FFB347",
    danger: "#FF5C8D",
  },
  text: {
    primary: "#F4F6FF",
    secondary: "rgba(244, 246, 255, 0.72)",
    muted: "rgba(244, 246, 255, 0.5)",
  },
  gradients: {
    hero: "radial-gradient(ellipse at top, #1f2557 0%, #0B1026 70%)",
    storyBackdrop:
      "linear-gradient(180deg, #0B1026 0%, #141a3a 100%)",
    auroraWispLeft:
      "radial-gradient(circle at 15% 30%, rgba(0, 255, 204, 0.22) 0%, transparent 55%)",
    auroraWispRight:
      "radial-gradient(circle at 85% 70%, rgba(170, 100, 255, 0.18) 0%, transparent 55%)",
    seminarWarm:
      "linear-gradient(135deg, #3a1f0a 0%, #6b3c12 45%, #c9803f 100%)",
    cardSurface:
      "linear-gradient(160deg, rgba(28, 35, 80, 0.95) 0%, rgba(20, 26, 58, 0.95) 100%)",
  },
  glow: {
    grandPrize:
      "0 0 40px rgba(0, 255, 204, 0.45), 0 0 80px rgba(0, 255, 204, 0.22)",
    cta: "0 0 24px rgba(0, 255, 204, 0.55)",
    soft: "0 8px 32px rgba(0, 255, 204, 0.12)",
  },
};

// Anchor IDs used for smooth-scrolling into specific sections.
export const AURORA_ANCHORS = {
  story: "aurora-story",
  promises: "aurora-promises",
  spotlight: "aurora-spotlight",
  trips: "aurora-trips",
  faqs: "aurora-faqs",
};
